module.exports = __webpack_public_path__ + "img/fig37.46963f41.jpg";